/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AgentOAuthAppClientCredentials } from '../model/agentOAuthAppClientCredentials';
// @ts-ignore
import { AgentOAuthAppSpec } from '../model/agentOAuthAppSpec';
// @ts-ignore
import { AssignRemoveOrgsFromOauthAppResponse } from '../model/assignRemoveOrgsFromOauthAppResponse';
// @ts-ignore
import { AssignRemoveOrgsFromOauthAppSpec } from '../model/assignRemoveOrgsFromOauthAppSpec';
// @ts-ignore
import { DeleteOAuthAppRequest } from '../model/deleteOAuthAppRequest';
// @ts-ignore
import { DeleteOAuthAppResponse } from '../model/deleteOAuthAppResponse';
// @ts-ignore
import { OAuthAppClientCredentials } from '../model/oAuthAppClientCredentials';
// @ts-ignore
import { OAuthAppClientResponse } from '../model/oAuthAppClientResponse';
// @ts-ignore
import { OAuthAppConfigsPatchSpec } from '../model/oAuthAppConfigsPatchSpec';
// @ts-ignore
import { OAuthAppConfigsResponse } from '../model/oAuthAppConfigsResponse';
// @ts-ignore
import { OAuthAppConfigsSpec } from '../model/oAuthAppConfigsSpec';
// @ts-ignore
import { OAuthAppInventoryPaginatedResponse } from '../model/oAuthAppInventoryPaginatedResponse';
// @ts-ignore
import { OAuthAppInventoryPatchSpec } from '../model/oAuthAppInventoryPatchSpec';
// @ts-ignore
import { OAuthAppInventoryResponse } from '../model/oAuthAppInventoryResponse';
// @ts-ignore
import { OAuthAppInventorySpec } from '../model/oAuthAppInventorySpec';
// @ts-ignore
import { OAuthAppRotateSecretSpec } from '../model/oAuthAppRotateSecretSpec';
// @ts-ignore
import { OAuthAppSpec } from '../model/oAuthAppSpec';
// @ts-ignore
import { ServerOAuthAppSpec } from '../model/serverOAuthAppSpec';
// @ts-ignore
import { TaskV2 } from '../model/taskV2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OauthAppsOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Assign or remove orgs to/from Organization Managed OAuth Apps.
     * Assign or remove all provided orgs to/from given client Id.
     * @param clientId OAuth client Id.
     * @param assignRemoveOrgsFromOauthAppSpec Assign/Remove orgs in given oauth app request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public assignRemoveOrgsOperator(clientId: string, assignRemoveOrgsFromOauthAppSpec: AssignRemoveOrgsFromOauthAppSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<AssignRemoveOrgsFromOauthAppResponse>;
    public assignRemoveOrgsOperator(clientId: string, assignRemoveOrgsFromOauthAppSpec: AssignRemoveOrgsFromOauthAppSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AssignRemoveOrgsFromOauthAppResponse>>;
    public assignRemoveOrgsOperator(clientId: string, assignRemoveOrgsFromOauthAppSpec: AssignRemoveOrgsFromOauthAppSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AssignRemoveOrgsFromOauthAppResponse>>;
    public assignRemoveOrgsOperator(clientId: string, assignRemoveOrgsFromOauthAppSpec: AssignRemoveOrgsFromOauthAppSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (clientId === null || clientId === undefined) {
            throw new Error('Required parameter clientId was null or undefined when calling assignRemoveOrgsOperator.');
        }
        if (assignRemoveOrgsFromOauthAppSpec === null || assignRemoveOrgsFromOauthAppSpec === undefined) {
            throw new Error('Required parameter assignRemoveOrgsFromOauthAppSpec was null or undefined when calling assignRemoveOrgsOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/${this.configuration.encodeParam({name: "clientId", value: clientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<AssignRemoveOrgsFromOauthAppResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: assignRemoveOrgsFromOauthAppSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create an agent oauth app in CSP and assign app to org.
     * Creates Organization Managed agent OAuth App. Also assigns created oauth app to organisation provided.
     * @param agentOAuthAppSpec Agent OAuth request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createAgentOAuthAppOperator(agentOAuthAppSpec: AgentOAuthAppSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<AgentOAuthAppClientCredentials>;
    public createAgentOAuthAppOperator(agentOAuthAppSpec: AgentOAuthAppSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AgentOAuthAppClientCredentials>>;
    public createAgentOAuthAppOperator(agentOAuthAppSpec: AgentOAuthAppSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AgentOAuthAppClientCredentials>>;
    public createAgentOAuthAppOperator(agentOAuthAppSpec: AgentOAuthAppSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (agentOAuthAppSpec === null || agentOAuthAppSpec === undefined) {
            throw new Error('Required parameter agentOAuthAppSpec was null or undefined when calling createAgentOAuthAppOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/agent`;
        return this.httpClient.request<AgentOAuthAppClientCredentials>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: agentOAuthAppSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create an native oauth app in CSP.
     * Create Organization Managed Native OAuth App.
     * @param oAuthAppSpec Native OAuth app request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createNativeOAuthOperator(oAuthAppSpec: OAuthAppSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OAuthAppClientResponse>;
    public createNativeOAuthOperator(oAuthAppSpec: OAuthAppSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OAuthAppClientResponse>>;
    public createNativeOAuthOperator(oAuthAppSpec: OAuthAppSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OAuthAppClientResponse>>;
    public createNativeOAuthOperator(oAuthAppSpec: OAuthAppSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (oAuthAppSpec === null || oAuthAppSpec === undefined) {
            throw new Error('Required parameter oAuthAppSpec was null or undefined when calling createNativeOAuthOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/native`;
        return this.httpClient.request<OAuthAppClientResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: oAuthAppSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Save the OAuth App configs into database
     * @param oAuthAppConfigsSpec OAuth app configs request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOAuthAppConfigsOperator(oAuthAppConfigsSpec: OAuthAppConfigsSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OAuthAppConfigsResponse>;
    public createOAuthAppConfigsOperator(oAuthAppConfigsSpec: OAuthAppConfigsSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OAuthAppConfigsResponse>>;
    public createOAuthAppConfigsOperator(oAuthAppConfigsSpec: OAuthAppConfigsSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OAuthAppConfigsResponse>>;
    public createOAuthAppConfigsOperator(oAuthAppConfigsSpec: OAuthAppConfigsSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (oAuthAppConfigsSpec === null || oAuthAppConfigsSpec === undefined) {
            throw new Error('Required parameter oAuthAppConfigsSpec was null or undefined when calling createOAuthAppConfigsOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/configs`;
        return this.httpClient.request<OAuthAppConfigsResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: oAuthAppConfigsSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Save the OAuth App information into database
     * @param oAuthAppInventorySpec OAuth app inventory request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOAuthAppsInventoryOperator(oAuthAppInventorySpec: OAuthAppInventorySpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OAuthAppInventoryResponse>;
    public createOAuthAppsInventoryOperator(oAuthAppInventorySpec: OAuthAppInventorySpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OAuthAppInventoryResponse>>;
    public createOAuthAppsInventoryOperator(oAuthAppInventorySpec: OAuthAppInventorySpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OAuthAppInventoryResponse>>;
    public createOAuthAppsInventoryOperator(oAuthAppInventorySpec: OAuthAppInventorySpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (oAuthAppInventorySpec === null || oAuthAppInventorySpec === undefined) {
            throw new Error('Required parameter oAuthAppInventorySpec was null or undefined when calling createOAuthAppsInventoryOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/inventory`;
        return this.httpClient.request<OAuthAppInventoryResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: oAuthAppInventorySpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create an server oauth app in CSP and assign app to org.
     * Creates Organization Managed server OAuth App. Also assigns created oauth app to organisation provided.
     * @param serverOAuthAppSpec Server OAuth request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createServerOAuthOperator(serverOAuthAppSpec: ServerOAuthAppSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OAuthAppClientCredentials>;
    public createServerOAuthOperator(serverOAuthAppSpec: ServerOAuthAppSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OAuthAppClientCredentials>>;
    public createServerOAuthOperator(serverOAuthAppSpec: ServerOAuthAppSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OAuthAppClientCredentials>>;
    public createServerOAuthOperator(serverOAuthAppSpec: ServerOAuthAppSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (serverOAuthAppSpec === null || serverOAuthAppSpec === undefined) {
            throw new Error('Required parameter serverOAuthAppSpec was null or undefined when calling createServerOAuthOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/server`;
        return this.httpClient.request<OAuthAppClientCredentials>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: serverOAuthAppSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete the OAuth App configs from database
     * @param appType OAuth App type
     * @param serviceType Service Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOAuthAppConfigsOperator(appType: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMCA' | 'DRC', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteOAuthAppConfigsOperator(appType: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMCA' | 'DRC', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteOAuthAppConfigsOperator(appType: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMCA' | 'DRC', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteOAuthAppConfigsOperator(appType: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMCA' | 'DRC', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appType === null || appType === undefined) {
            throw new Error('Required parameter appType was null or undefined when calling deleteOAuthAppConfigsOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling deleteOAuthAppConfigsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>appType, 'app-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/configs`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete the OAuth App from database
     * @param appId OAuth App id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOAuthAppsInventoryOperator(appId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteOAuthAppsInventoryOperator(appId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteOAuthAppsInventoryOperator(appId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteOAuthAppsInventoryOperator(appId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling deleteOAuthAppsInventoryOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/inventory/${this.configuration.encodeParam({name: "appId", value: appId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete Organization Managed OAuth Apps.
     * Delete given set of oauth apps. You can delete all apps for the organisation by setting delete_all true and providing optional region, service type.
     * @param orgId Organization identifier
     * @param deleteOAuthAppRequest Delete OAuth request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOAuthOperator(orgId: string, deleteOAuthAppRequest: DeleteOAuthAppRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DeleteOAuthAppResponse>;
    public deleteOAuthOperator(orgId: string, deleteOAuthAppRequest: DeleteOAuthAppRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DeleteOAuthAppResponse>>;
    public deleteOAuthOperator(orgId: string, deleteOAuthAppRequest: DeleteOAuthAppRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DeleteOAuthAppResponse>>;
    public deleteOAuthOperator(orgId: string, deleteOAuthAppRequest: DeleteOAuthAppRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling deleteOAuthOperator.');
        }
        if (deleteOAuthAppRequest === null || deleteOAuthAppRequest === undefined) {
            throw new Error('Required parameter deleteOAuthAppRequest was null or undefined when calling deleteOAuthOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/orgs/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<DeleteOAuthAppResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: deleteOAuthAppRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all Organization Managed OAuth Apps either using searchTerm or specifying anyOf/allOf serviceType, orgId and region.
     * Get all oauth apps for given org. Please use either searchTerm or specific params - orgId, regionId and serviceType.
     * @param serviceType Service Type
     * @param orgId ORG identifier
     * @param regionId Region ID of Cloud Provider
     * @param searchTerm Filter oauth app result.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllOAuthAppsOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', orgId?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', searchTerm?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<object>>;
    public getAllOAuthAppsOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', orgId?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', searchTerm?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<object>>>;
    public getAllOAuthAppsOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', orgId?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', searchTerm?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<object>>>;
    public getAllOAuthAppsOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', orgId?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', searchTerm?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling getAllOAuthAppsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>regionId, 'region-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>searchTerm, 'search-term');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps`;
        return this.httpClient.request<Array<object>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all OAuth app configs from database.
     * @param appType OAuth App type
     * @param serviceType Service Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOAuthAppConfigsOperator(appType?: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMC_POOL' | 'DRC', serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<OAuthAppConfigsResponse>>;
    public getOAuthAppConfigsOperator(appType?: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMC_POOL' | 'DRC', serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<OAuthAppConfigsResponse>>>;
    public getOAuthAppConfigsOperator(appType?: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMC_POOL' | 'DRC', serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<OAuthAppConfigsResponse>>>;
    public getOAuthAppConfigsOperator(appType?: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMC_POOL' | 'DRC', serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>appType, 'app-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/configs`;
        return this.httpClient.request<Array<OAuthAppConfigsResponse>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get OAuth app filtered by appId from database.
     * @param appId OAuth App id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOAuthAppsInventoryByAppIdOperator(appId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OAuthAppInventoryResponse>;
    public getOAuthAppsInventoryByAppIdOperator(appId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OAuthAppInventoryResponse>>;
    public getOAuthAppsInventoryByAppIdOperator(appId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OAuthAppInventoryResponse>>;
    public getOAuthAppsInventoryByAppIdOperator(appId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling getOAuthAppsInventoryByAppIdOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/inventory/${this.configuration.encodeParam({name: "appId", value: appId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<OAuthAppInventoryResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all OAuth apps from database.
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the OAuth Apps by this column
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param appName OAuth app name
     * @param appDescription OAuth app description
     * @param accountType Account type
     * @param appId OAuth app Id
     * @param creationType OAuth app creation type
     * @param orgId ORG identifier
     * @param serviceType Service Type
     * @param appType OAuth App type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOAuthAppsInventoryOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'name' | 'description' | 'accountType' | 'secretRotationTimestamp' | 'serviceType' | 'creationType' | 'type' | 'createdTimestamp' | 'updatedTimestamp', pageNo?: number, pageSize?: number, appName?: string, appDescription?: string, accountType?: 'ADMIN' | 'SHADOW', appId?: string, creationType?: 'STATIC' | 'DYNAMIC', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', appType?: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMC_POOL' | 'DRC', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OAuthAppInventoryPaginatedResponse>;
    public getOAuthAppsInventoryOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'name' | 'description' | 'accountType' | 'secretRotationTimestamp' | 'serviceType' | 'creationType' | 'type' | 'createdTimestamp' | 'updatedTimestamp', pageNo?: number, pageSize?: number, appName?: string, appDescription?: string, accountType?: 'ADMIN' | 'SHADOW', appId?: string, creationType?: 'STATIC' | 'DYNAMIC', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', appType?: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMC_POOL' | 'DRC', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OAuthAppInventoryPaginatedResponse>>;
    public getOAuthAppsInventoryOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'name' | 'description' | 'accountType' | 'secretRotationTimestamp' | 'serviceType' | 'creationType' | 'type' | 'createdTimestamp' | 'updatedTimestamp', pageNo?: number, pageSize?: number, appName?: string, appDescription?: string, accountType?: 'ADMIN' | 'SHADOW', appId?: string, creationType?: 'STATIC' | 'DYNAMIC', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', appType?: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMC_POOL' | 'DRC', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OAuthAppInventoryPaginatedResponse>>;
    public getOAuthAppsInventoryOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'name' | 'description' | 'accountType' | 'secretRotationTimestamp' | 'serviceType' | 'creationType' | 'type' | 'createdTimestamp' | 'updatedTimestamp', pageNo?: number, pageSize?: number, appName?: string, appDescription?: string, accountType?: 'ADMIN' | 'SHADOW', appId?: string, creationType?: 'STATIC' | 'DYNAMIC', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', appType?: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMC_POOL' | 'DRC', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getOAuthAppsInventoryOperator.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getOAuthAppsInventoryOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>appName, 'app-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>appDescription, 'app-description');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>accountType, 'account-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>appId, 'app-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>creationType, 'creation-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>appType, 'app-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/inventory`;
        return this.httpClient.request<OAuthAppInventoryPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rotate secrets for OAuth apps which are available in database
     * Helps in rotating secrets
     * @param oAuthAppRotateSecretSpec OAuth app inventory request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rotateOAuthAppSecretOperator(oAuthAppRotateSecretSpec: OAuthAppRotateSecretSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public rotateOAuthAppSecretOperator(oAuthAppRotateSecretSpec: OAuthAppRotateSecretSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public rotateOAuthAppSecretOperator(oAuthAppRotateSecretSpec: OAuthAppRotateSecretSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public rotateOAuthAppSecretOperator(oAuthAppRotateSecretSpec: OAuthAppRotateSecretSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (oAuthAppRotateSecretSpec === null || oAuthAppRotateSecretSpec === undefined) {
            throw new Error('Required parameter oAuthAppRotateSecretSpec was null or undefined when calling rotateOAuthAppSecretOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/rotate-secret`;
        return this.httpClient.request<TaskV2>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: oAuthAppRotateSecretSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update the OAuth App configs in database
     * @param appType OAuth App type
     * @param serviceType Service Type
     * @param oAuthAppConfigsPatchSpec Web OAuth app request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateOAuthAppConfigsOperator(appType: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMCA' | 'DRC', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', oAuthAppConfigsPatchSpec: OAuthAppConfigsPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OAuthAppConfigsResponse>;
    public updateOAuthAppConfigsOperator(appType: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMCA' | 'DRC', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', oAuthAppConfigsPatchSpec: OAuthAppConfigsPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OAuthAppConfigsResponse>>;
    public updateOAuthAppConfigsOperator(appType: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMCA' | 'DRC', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', oAuthAppConfigsPatchSpec: OAuthAppConfigsPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OAuthAppConfigsResponse>>;
    public updateOAuthAppConfigsOperator(appType: 'WEB' | 'ASUP' | 'NATIVE' | 'SRM_AGENT' | 'VCF' | 'VMC' | 'VMCA' | 'DRC', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', oAuthAppConfigsPatchSpec: OAuthAppConfigsPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appType === null || appType === undefined) {
            throw new Error('Required parameter appType was null or undefined when calling updateOAuthAppConfigsOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling updateOAuthAppConfigsOperator.');
        }
        if (oAuthAppConfigsPatchSpec === null || oAuthAppConfigsPatchSpec === undefined) {
            throw new Error('Required parameter oAuthAppConfigsPatchSpec was null or undefined when calling updateOAuthAppConfigsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>appType, 'app-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/configs`;
        return this.httpClient.request<OAuthAppConfigsResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: oAuthAppConfigsPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update the OAuth App information in database
     * @param appId OAuth App id
     * @param oAuthAppInventoryPatchSpec Web OAuth app request payload.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateOAuthAppsInventoryOperator(appId: string, oAuthAppInventoryPatchSpec: OAuthAppInventoryPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OAuthAppInventoryResponse>;
    public updateOAuthAppsInventoryOperator(appId: string, oAuthAppInventoryPatchSpec: OAuthAppInventoryPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OAuthAppInventoryResponse>>;
    public updateOAuthAppsInventoryOperator(appId: string, oAuthAppInventoryPatchSpec: OAuthAppInventoryPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OAuthAppInventoryResponse>>;
    public updateOAuthAppsInventoryOperator(appId: string, oAuthAppInventoryPatchSpec: OAuthAppInventoryPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling updateOAuthAppsInventoryOperator.');
        }
        if (oAuthAppInventoryPatchSpec === null || oAuthAppInventoryPatchSpec === undefined) {
            throw new Error('Required parameter oAuthAppInventoryPatchSpec was null or undefined when calling updateOAuthAppsInventoryOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/oauth-apps/inventory/${this.configuration.encodeParam({name: "appId", value: appId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<OAuthAppInventoryResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: oAuthAppInventoryPatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
